import { render, staticRenderFns } from "./OoaDataTable.vue?vue&type=template&id=e972674c&scoped=true&"
import script from "./OoaDataTable.vue?vue&type=script&lang=js&"
export * from "./OoaDataTable.vue?vue&type=script&lang=js&"
import style0 from "./OoaDataTable.vue?vue&type=style&index=0&id=e972674c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e972674c",
  null
  
)

export default component.exports